import {useSelector} from "react-redux";

import {head} from "@pg-mono/nodash";

import {IRPStore} from "../../../app/rp_reducer";
import {findVariableByValue} from "../../../variables/utils/find_variable_by_value";
import {IOfferDetail} from "../../types/IOfferDetail";

const INFO_FROM_VENDOR = "Informacja u dewelopera";

export const useOfferStandardDescription = (standardDescription: IOfferDetail["standard_description"]): string => {
    const offerStandardDescriptionTypes = useSelector((state: IRPStore) => state.variables.data?.offer_standard_description_type);

    if (!offerStandardDescriptionTypes) {
        return INFO_FROM_VENDOR;
    }

    const standardType: number | undefined = head(standardDescription.types);

    if (standardType) {
        return findVariableByValue(offerStandardDescriptionTypes || [], standardType)?.label || INFO_FROM_VENDOR;
    }

    return INFO_FROM_VENDOR;
};
import {useSelector} from "react-redux";

import {head} from "@pg-mono/nodash";

import {IRPStore} from "../../../app/rp_reducer";
import {findVariableByValue} from "../../../variables/utils/find_variable_by_value";
import {IOfferDetail} from "../../types/IOfferDetail";

const INFO_FROM_VENDOR = "Informacja u dewelopera";

export const useOfferStandardDescription = (standardDescription: IOfferDetail["standard_description"]): string => {
    const offerStandardDescriptionTypes = useSelector((state: IRPStore) => state.variables.data?.offer_standard_description_type);

    if (!offerStandardDescriptionTypes) {
        return INFO_FROM_VENDOR;
    }

    const standardType: number | undefined = head(standardDescription.types);

    if (standardType) {
        return findVariableByValue(offerStandardDescriptionTypes || [], standardType)?.label || INFO_FROM_VENDOR;
    }

    return INFO_FROM_VENDOR;
};
